const server = {
  // endPoint: "https://portfolioadmin.pharsights.com/", // QA
  endPoint: "https://portfoliodev.pharsights.com/", //for dev server
  // endPoint1: "https://portfolioadmin.pharsights.com/pm_backend/", //QA
  endPoint1: "https://portfoliodev.pharsights.com/pm_backend/", //for dev server
};

export const environment = {
  production: true,
  apiServer: server.endPoint1,
  ip: server.endPoint,
};
